import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ExaminationSessionSlide, ExaminationSessionSlideList } from '../model/examination-session-slide.model';

@Injectable()
export class ExaminationSessionSlideService extends KiwixiService {

    public api = environment.server + 'examinations_sessions_slides/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getExaminationSessionSlideById(_id): Observable<ExaminationSessionSlide> {
        const url = this.api + _id + '/';
        return this.getExaminationSessionSlideByUrl(url);
    }

    getExaminationSessionSlideByUrl(_url): Observable<ExaminationSessionSlide> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationSessionSlide>(_url, {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<any>(`getExaminationSessionSlide`))
            );
    }

    getExaminationSessionSlides(params: HttpParams): Observable<ExaminationSessionSlideList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationSessionSlideList>(this.api, {
            headers: header,
            params: params
        })
            .pipe(
                map(_ExaminationSessionSlides => _ExaminationSessionSlides),
                catchError(this.handleErrorObservable<ExaminationSessionSlideList>(`getObservableExaminationSessionSlides`))
            );
    }

    patchExaminationSessionSlide(_id, params) {
        const url = this.api + _id + '/';
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<ExaminationSessionSlide>(url, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationSessionSlide>(`Création d'une fiche`)),
            );
    }
}
